import { Link, useLocation } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';

import logoImage from '@/assets/OKYC logo.webp';

import { UserMenu } from './user-menu';

interface HeaderProps {
  balance?: number;
  showBackButton?: boolean;
}

// Routes that should show the back button
const ROUTES_WITH_BACK_BUTTON = ['/settings'];

export function Header({ balance = 0, showBackButton }: HeaderProps) {
  const location = useLocation();

  // Show back button if explicitly set or if on a route that needs it
  const shouldShowBackButton =
    showBackButton ?? ROUTES_WITH_BACK_BUTTON.includes(location.pathname);
  const formattedBalance = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(balance);

  return (
    <header className="relative z-20 flex h-16 items-center justify-between border-b bg-card px-6">
      <div className="flex items-center gap-[30px]">
        <Link to="/">
          <img src={logoImage} alt="OKYC" className="h-8" />
        </Link>
        {shouldShowBackButton && (
          <button
            type="button"
            onClick={() => window.history.back()}
            className="flex items-center text-gray-600 hover:text-gray-900"
            aria-label="Go back"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
        )}
      </div>
      <div className="flex items-center gap-4">
        <span className="text-[14px] text-[#051923]">Balance: {formattedBalance}</span>
        <UserMenu />
      </div>
    </header>
  );
}
